@use "stylesheets/utility/variables";

.headerWrapper {
  padding: 15px 0;
  border-bottom: 1px solid var(--border-default);
  font-size: variables.$small-text-size;
}
